// extracted by css-extract-rspack-plugin
export default {"icon":"ExpandableSectionIcon-module__icon__gEAlL","isExpanded":"ExpandableSectionIcon-module__isExpanded__VCC4o"};